module.exports = __webpack_public_path__ + "img/tiktok.091471df.png";